import { GlobalRoleDto } from "@admin_api/models/global-role-dto";

export class RolesState {
    loading = false;
    error = null;
    record: Array<GlobalRoleDto> = [];
}
